var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useContext } from 'react';
import { FormContextInstance } from '../../context';
export const useForm = () => (_react_refresh_temp_1(), useContext(FormContextInstance));
_react_refresh_temp_1(useForm, "gDsCjeeItUuvgOWf1v4qoK9RF6k=");
